import React, {Component} from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import {
  path,
  mergeDeepLeft,
  clone
} from 'ramda';
import Breadcrumbs from '../../common/Breadcrumbs';
import Input from '../../common/Input';
import ReactSelectWrapper from '../../common/ReactSelectWrapper';
import ReactMultiSelectWrapper from '../../common/ReactMultiSelectWrapper';
import Select from '../../common/Select';
import DatePicker from '../../common/DatePicker';
import Currency from '../../common/Currency';
import '../../css/forms/default-forms.css';
import {basic as fields, job_summary, subtotals} from './fields';
import {getList, getContactsByProjectId} from '../../api/projects';
import {
  archiveQuoteById,
  sendEmail, updateQuote,
} from '../../api/quotes';
import {processFields} from '../../utils/prePost';
import {
  fetchQuoteByIdWithRole,
  createWOBasedOnQuoteData,
  getPdfFileForQuote,
} from '../../api/quotes';
import {linkDataToFields} from '../../utils/fields';
import approve from 'approvejs';
import ConfirmAction from '../../common/ConfirmAction';
import {changeModalState} from '../../actions/modal';
import {getSalesPersonsListAll, getWORecent} from "../../api/task";
import {_prepareDataForWo} from "./data";
import {clearCurrentQuote} from '../../actions/quotes';
import TextArea from "../../common/TextArea";
import hasAccess from "../../helpers/permissionChecker";
import CKEditorComponent from "../../сomponents/CKEditor";
import moment from 'moment';

import PopUp from '../../common/PopUp';
import CheckBox from '../../common/CheckBox';
import SendEmailPopup from "./sendEmailPopup";

const defaultSubtotals = "<table border=\"1\" bordercolor=\"#ccc\" cellpadding=\"5\" cellspacing=\"0\" style=\"border-collapse:collapse\">\n\t<tbody>\n\t\t<tr>\n\t\t\t<td>Subtotal 1</td>\n\t\t\t<td>$00.00</td>\n\t\t</tr>\n\t</tbody>\n</table>\n\n<p>&nbsp;</p>\n";
export class QuotesEdit extends Component {

  constructor(props) {
    super(props);
    this.state = {
      submit: false,
      errors: [],
      fields: clone(fields),
      descriptionIdsForRemove: [],
      subtotalIdsForRemove: [],
    };
    this.submit = this.submit.bind(this);
    this.handlePdfPreview = this.handlePdfPreview.bind(this);
    this.changeFormValue = this.changeFormValue.bind(this);
    this.cancel = this.cancel.bind(this);
    this.cancel = this.cancel.bind(this);
    this.fetchDataRouteById = this.fetchDataRouteById.bind(this);
    this.createWOFromQuote = this.createWOFromQuote.bind(this);
    this.archiveWo = this.archiveWo.bind(this);
    this.handleCreateWo = this.handleCreateWo.bind(this);
    this.handleArchive = this.handleArchive.bind(this);
    this.logs = this.logs.bind(this);
    this.sendEmailByQuoteId = this.sendEmailByQuoteId.bind(this);
    this.donwloadPdfPreview = this.donwloadPdfPreview.bind(this);
    this.parseContactList = this.parseContactList.bind(this);
    this.ckeEditorScopeOfWordRef = element => {
      this.scopeOfWordRef = element;
    };
    this.ckeEditorSubtotalsRef = element => {
      this.subtotalsRef = element;
    };
    this.handleAddContacts = this.handleAddContacts.bind(this);

  }

  componentDidMount() {
    this.fetchDataRouteById();
    this.props.getCustomerList();
    this.props.getSalesPersonsList();
  }

  donwloadPdfPreview() {
    const id = path(['match', 'params', 'id'], this.props);
    this.props.getPdf(id);
  }

  componentWillUnmount() {
    this.props.clearCurrentQuoteFromStore();
  }

  componentDidUpdate(prevProps, prevState) {
    const prevData = path(['quotes', 'quote'], prevProps);
    const data = path(['quotes', 'quote'], this.props);
    if (data && !data.error && prevData !== data) {
      const fieldsCloned = clone(fields);
      const newFields = linkDataToFields(data.quote, fieldsCloned, null);

      const customerId = newFields && newFields.customer && newFields.customer.value;
      this.props.getContactList(customerId);

      this.setState({
        fields: newFields,
      });
    }
  }

  fetchDataRouteById() {
    const id = path(['match', 'params', 'id'], this.props);
    this.props.getDataById(id);
  }

  submitForm(e, fields) {
    e.preventDefault();
    let check = true;
    for (let field in fields) {
      fields[field].errors = [];
      if (fields[field].value) {
        let result = approve.value(fields[field].value, fields[field].rules);
        if (result.errors.length > 0) {
          check = false;
          fields[field].errors = Array.from(result.errors);
        }
      }
    }
    return {
      fields,
      check,
    };
  }

  submit(e, emptySubtotals = false) {

    Date.prototype.toJSON = function () {
      let timezoneOffsetInHours = -(this.getTimezoneOffset() / 60); //UTC minus local time
      let sign = timezoneOffsetInHours >= 0 ? '+' : '-';
      let leadingZero = (Math.abs(timezoneOffsetInHours) < 10) ? '0' : '';

      //It's a bit unfortunate that we need to construct a new Date instance
      //(we don't want _this_ Date instance to be modified)
      let correctedDate = new Date(this.getFullYear(), this.getMonth(),
        this.getDate(), this.getHours(), this.getMinutes(), this.getSeconds(),
        this.getMilliseconds());
      correctedDate.setHours(this.getHours() + timezoneOffsetInHours);
      let iso = correctedDate.toISOString().replace('Z', '');

      return iso + sign + leadingZero + Math.abs(timezoneOffsetInHours).toString() + ':00';
    };

    e.preventDefault();
    let result = this.submitForm(e, this.state.fields);
    if (result.check === false) {
      this.setState({
        fields: result.fields,
      });
    } else {
      let data = processFields(this.state.fields);
      data.total_amount = data.total_amount.replace(',', '');
      data.scope_of_work = this.scopeOfWordRef.editor.getData();
      data.subtotals = this.subtotalsRef.editor.getData();
      data.amount_tbd = data.amount_tbd ? 1 : 0;
      if (emptySubtotals) {
        data.subtotals = '';
        data = JSON.stringify(data);
        this.props.saveForm(
          {
            id: path(['match', 'params', 'id'], this.props),
            project_id: path(['users', 'userProfile', 'id'], this.props),
            quote: data,
          });
      } else {
        data = JSON.stringify(data);
        this.props.saveForm(
          {
            id: path(['match', 'params', 'id'], this.props),
            project_id: path(['users', 'userProfile', 'id'], this.props),
            quote: data,
          });
      }

    }
    return false;
  }

  updateCustomerValue(newValue) {
    this.setState({
      selectValue: newValue
    });
  }

  changeFormValue(field, newObject) {
    let stateClone = clone(this.state);
    stateClone.fields[field] = newObject;

    if (field == 'customer') {
      const customerList = this.parseCustomersList(path(['projects', 'list'], this.props));
      const selectedCustomer = customerList.find((value) => value.value === newObject.value);
      if (selectedCustomer) {
        const customerLabel = selectedCustomer.label.split(" ")[0];
        stateClone.fields.name.value = `${customerLabel} (RFQ)`;
        this.props.getContactList(selectedCustomer.value);
      } else {
        this.props.getContactList(undefined);
      }
    }
    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  cancel() {
    this.props.goToQuote();
  }

  getStatuses() {
    return [
      {
        value: 1,
        text: 'New',
      },
      {
        value: 2,
        text: 'Pending',
      },
      {
        value: 3,
        text: 'Approved',
      },
      {
        value: 4,
        text: 'approved by customer',
        label: 'Approved by customer'
      },
      {
        value: 5,
        text: 'Declined',
      },
      {
        value: 6,
        text: 'Canceled',
      },
    ];
  }

  parseCustomersList(arr) {
    const arrCustomers = [];

    if (arr) {
      for (let i = 0; i < arr.length; i++) {
        arrCustomers.push({
          value: arr[i].id,
          label: arr[i].name,
        });
      }
    }

    return arrCustomers;
  }

  parseContactList(arr) {
    const arrContacts = [];

    if (arr) {
      for (let i = 0; i < arr.length; i++) {
        let type = arr[i].type.join('/');
        type = type ? ` (${type})`:type;
        const phone = arr[i].phone ? `, tel.: ${arr[i].phone}`: '';
        const email = arr[i].email ? `, email.: ${arr[i].email}`: '';

        arrContacts.push({
          value: arr[i].id,
          label: `${arr[i].firstname} ${arr[i].lastname}${phone}${email}${type}`,
          name: `${arr[i].firstname} ${arr[i].lastname}`
        });
      }
    }

    return arrContacts;
  }

  handleCreateWo() {
    this.props.handleModalState({
      isOpen: !this.props.modal.isOpen,
      modalId: 'createWo',
      handler: this.createWOFromQuote,
    });
  }

  logs() {
    const id = path(['match', 'params', 'id'], this.props);
    this.props.goToLogs(id);
  }

  handleArchive() {
    this.props.handleModalState({
      isOpen: !this.props.modal.isOpen,
      modalId: 'archiveQuote',
      handler: this.archiveWo,
    });
  }

  handlePdfPreview(e) {
    if (this.subtotalsRef.editor.getData().replace(/\s/g,'') === defaultSubtotals.replace(/\s/g,'')) {
      this.props.handleModalState({
        isOpen: !this.props.modal.isOpen,
        modalId: 'previewPDF',
        handler: this.donwloadPdfPreview,
        save: () => this.submit(e, true)
      });
    } else {
      this.donwloadPdfPreview();
    }
  }

  createWOFromQuote() {
    const id = path(['match', 'params', 'id'], this.props);
    const fields = _prepareDataForWo(this.state.fields, id);
    this.props.createWO(fields);
  }

  archiveWo() {
    const id = path(['match', 'params', 'id'], this.props);
    this.props.archive(id);
  }

  sendEmailByQuoteId() {
    // const id = path(['match', 'params', 'id'], this.props);
    //
    // this.props.sendEmailById(id);
    const id = path(['match', 'params', 'id'], this.props);
    const contactsList = this.parseContactList(path(['projects', 'contacts'], this.props));

    this.props.handleModalState({
      id: id,
      handler: sendEmail,
      recipients: clone(contactsList),
      selectedItems: this.state.fields['contacts'].value,
      isOpen: !this.props.modal.isOpen,
      modalId: 'sendEmailPopup',
    });

  }

  handleAddContacts() {
    const selectedCustomer = this.state.fields['customer'].value;
    const { goToCustomer } = this.props;
    goToCustomer(selectedCustomer);
  }

  parseSalesPersonsList(salesPersonsList) {
    return (salesPersonsList || []).map((item) => ({
      value: item.id,
      label: `${item.firstname} ${item.lastname}`,
    }));
  }

  render() {
    const quoteAuthor = path(['quotes', 'quote', 'user', 'id'], this.props);
    const lastSentEmailDate = path(['quotes', 'quote', 'quote', 'last_sent_email_date'], this.props);

    const hasAccessForEdit = hasAccess({
      'permAreaKey': 'quote',
      'permTypeKey': 'edit',
      'idForCheckingAuthor': quoteAuthor
    });
    const disableFieldForEdit = !hasAccessForEdit;
    const disableTotalAmount = disableFieldForEdit || this.state.fields['amount_tbd'].value === true || this.state.fields['amount_tbd'].value === 1;
    const customerList = this.parseCustomersList(path(['projects', 'list'], this.props));
    const contactsList = this.parseContactList(path(['projects', 'contacts'], this.props));
    const selectedCustomer = this.state.fields['customer'].value;
    const salesPersonsList = this.parseSalesPersonsList(path(['tasks', 'salesPersonsList'], this.props));

    return (
      <div style={{paddingBottom: '25px'}}>
        <Breadcrumbs list={[
          {url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard'},
          {url: '/pages/quotes', icon: 'format_quote', name: 'Quotes'},
          {icon: 'edit', name: 'Quote Edit'},
        ]}/>
        <div className="card rounded">
          <div className="card-header rounded-top">
            Quotes Edit
          </div>
          <div className="card-block">
            <div style={{paddingBottom: '20px'}} className="float-right">
              <button
                type="button"
                className={'btn btn-info btn-outline'}
                onClick={this.handlePdfPreview}
              >
                <i className="fa fa-file-pdf-o"></i>
                <span style={{paddingLeft: '3px'}}>Print Preview</span>
              </button>
              {hasAccessForEdit &&
              <button className={'btn btn-success btn-outline'}
                      onClick={this.submit}
                      style={{marginLeft: '10px'}}>
                <i className="fa fa-check"></i>
                <span style={{paddingLeft: '3px'}}>Save & Continue</span>
              </button>
              }
              {hasAccess({'permAreaKey': 'workOrder', 'permTypeKey': 'create'}) &&
              <button
                className={'btn btn-info btn-outline'}
                onClick={this.handleCreateWo}
                style={{marginLeft: '10px'}}
              >
                <i className="fa fa-calendar-o"></i>
                <span style={{paddingLeft: '3px'}}>Create WO based on this Quote</span>
              </button>
              }
              <button
                type="button"
                className={'btn btn-default btn-outline'}
                onClick={this.logs}
                style={{
                  marginLeft: '10px',
                }}
              >
                <i className="fa fa-info-circle"></i>
                <span style={{ paddingLeft: '3px' }}>Logs</span>
              </button>
              {hasAccess({'permAreaKey': 'quote', 'permTypeKey': 'archive', 'idForCheckingAuthor': quoteAuthor}) &&
              <button
                className={'btn btn-primary btn-outline'}
                onClick={this.handleArchive}
                style={{marginLeft: '10px',}}
              >
                <i className="fa fa-trash"></i>
                <span style={{paddingLeft: '3px'}}>Archive</span>
              </button>
              }
              {hasAccess({'permAreaKey': 'quote', 'permTypeKey': 'sendEmail', 'idForCheckingAuthor': quoteAuthor}) &&
              <button
                className={'btn btn-warning btn-outline'}
                onClick={() => {
                  this.sendEmailByQuoteId();
                }}
                style={{marginLeft: '10px'}}
              >
                <i className="fa fa-send"></i>
                <span style={{paddingLeft: '3px'}}>Send Email</span>
              </button>
              }
              <button
                className={'btn btn-danger btn-outline'}
                style={{marginLeft: '10px'}}
                onClick={this.cancel}
              >
                <i className="fa fa-remove"></i>
                <span style={{paddingLeft: '3px'}}>Cancel</span>
              </button>
            </div>
            <div style={{clear: 'both'}}></div>
            {hasAccess({'permAreaKey': 'quote', 'permTypeKey': 'sendEmail', 'idForCheckingAuthor': quoteAuthor}) && lastSentEmailDate &&
            <div className={'float-right'}>
              <span>Last email sent on {moment(lastSentEmailDate).format('M/D/YYYY HH:mm')}</span>
            </div>
            }
            <form onSubmit={this.submit}>
              <div className="col-12" style={{clear: 'both'}}>
                <ReactSelectWrapper
                  disabled={disableFieldForEdit}
                  options={customerList}
                  field={this.state.fields['customer']}
                  onChange={this.changeFormValue}
                />

                {contactsList && contactsList.length && (<ReactMultiSelectWrapper
                    options={contactsList}
                    autoFocus={false}
                    field={this.state.fields['contacts']}
                    onChange={this.changeFormValue}
                    transformSelected={o => ({...o, title: o.label, label: o.name})}
                />) || null}
                {selectedCustomer && (<PopUp
                    id={'CustomerContactmissing'}
                    show={selectedCustomer && contactsList && contactsList.length === 0}
                    title={'Customer Contact missing'}
                    onAddContacts={this.handleAddContacts}
                    content={'There are no contacts assigned to the selected Customer. Please add at least one Contact to Proceed'}
                    yesCaption={'Manage Customer Contacts'}
                />)}
                <ReactSelectWrapper
                  options={salesPersonsList}
                  className={'col-12'}
                  autoFocus={false}
                  field={this.state.fields['sales_rep']}
                  onChange={this.changeFormValue}
                />
                <DatePicker
                  disabled={disableFieldForEdit}
                  field={this.state.fields['estimate_date']}
                  onChange={this.changeFormValue}
                />
                <Select
                  disabled={disableFieldForEdit}
                  options={this.getStatuses()}
                  field={this.state.fields['status']}
                  onChange={this.changeFormValue}
                />
                <Input
                  disabled={disableFieldForEdit}
                  field={this.state.fields['name']}
                  onChange={this.changeFormValue}
                />
                <TextArea
                  disabled={disableFieldForEdit}
                  field={this.state.fields['description']}
                  onChange={this.changeFormValue}
                />
                <CKEditorComponent
                  field={this.state.fields['scope_of_work']}
                  refLink={this.ckeEditorScopeOfWordRef}
                />
                <div style={{marginTop: '20px', marginBottom: '20px'}}>
                  <CKEditorComponent
                    field={this.state.fields['subtotals']}
                    refLink={this.ckeEditorSubtotalsRef}
                  />
                </div>
                <div className="d-flex">
                  <div className="flex-fill">
                    <Currency
                      disabled={disableTotalAmount}
                      field={this.state.fields['total_amount']}
                      onChange={this.changeFormValue}
                    />
                  </div>
                  <div className="align-self-end p-2">
                    <CheckBox
                      disabled={disableFieldForEdit}
                      field={this.state.fields['amount_tbd']}
                      onChange={this.changeFormValue}
                    />
                  </div>
                </div>
              </div>
            </form>
            <ConfirmAction
              id={'createWo'}
              title={'Create work order based on this quote'}
              content={'Are you sure you want to create WO based on this Quote?'}
            />
            <ConfirmAction
              id={'archiveQuote'}
              title={'Archive Quote'}
              content={'Are you sure you want to Archive this Quote?'}
            />
            <ConfirmAction
              id={'previewPDF'}
              title={'Preview PDF Quote'}
              content={'You have not edited or removed example Subtotal record. Would you like to Cancel and edit it or Remove Subtotals block and see Preview?'}
            />
            <SendEmailPopup id={'sendEmailPopup'}></SendEmailPopup>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    getPdf: (id) => {
      getPdfFileForQuote(id)(dispatch);
    },
    saveForm: (data) => {
      updateQuote(data)(dispatch);
    },
    goToQuote: () => {
      dispatch(push('/pages/quotes'));
    },
    getDataById: (id) => {
      fetchQuoteByIdWithRole(id)(dispatch);
    },
    clearCurrentQuoteFromStore: () => {
      dispatch(clearCurrentQuote());
    },

    getContactList: (id) => {
      getContactsByProjectId(id)(dispatch);
    },

    getCustomerList: () => {
      getList()(dispatch);
    },
    createWO: (data) => {
      createWOBasedOnQuoteData(data)(dispatch);
    },
    archive: (id) => {
      archiveQuoteById(id)(dispatch);
    },
    handleModalState: (data) => {
      dispatch(changeModalState(data));
    },
    getWoIdForCustomer: (id) => {
      return getWORecent(id)(dispatch);
    },
    goToLogs: (id) => {
      dispatch(push('/pages/quote-logs/' + id));
    },
    goToCustomer: (id) => {
      dispatch(push('/pages/edit-customer/' + id))
    },
    getSalesPersonsList: () => {
      getSalesPersonsListAll()(dispatch)
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(QuotesEdit);



// WEBPACK FOOTER //
// ./src/containers/QuotesEdit/index.js